import { render, staticRenderFns } from "./Archiv.vue?vue&type=template&id=0bf78e86&scoped=true&"
import script from "./Archiv.vue?vue&type=script&lang=js&"
export * from "./Archiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf78e86",
  null
  
)

export default component.exports